










import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class DropdownMenu extends Vue {

    private open: boolean = false;

    private mounted() {
        document.getElementById('menu-container')?.addEventListener('click', this.toggleMenu)
    }

    private destroyed() {
        document.getElementById('menu-container')?.removeEventListener('click', this.toggleMenu)
    }

    private toggleMenu() {
        this.open = !this.open;
    }
}
